module.exports = __webpack_public_path__ + "media/images/mypage_main_visual-f00df392f20ac5b6d9a13510e30bc68a.png";